import React from "react";

const CircularProgress = () => {
  return (
    <svg viewBox="25 25 50 50" className="loading">
      <circle cx="50" cy="50" r="20"></circle>
    </svg>
  );
};

export default CircularProgress;
